// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.webhooks-details-root {
  width: 100%;
  padding: 24px 0px;
}

.webhooks-details-container {
  width: 100%;
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  flex-shrink: 0;
  padding: 30px;
}

.webhooks-details-summary {
  display: flex;
  gap: 46px;
  width: 100%;
}

.webhooks-details-summary-left {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 60%;
}

.webhooks-details-summary-left-children {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.webhooks-details-summary-right {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 30%;
}

.time-status-error-container {
  display: flex;
  flex-direction: row;
  gap: 46px;
}

.webhooks-detailed-report {
  display: flex;
}

.webhooks-detailed-report-root {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}

.webhooks-detailed-report {
  display: flex;
  gap: 46px;
}

.webhooks-detailed-report-g {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
}

.active-elements {
  display: flex;
  padding: 5px 8px;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 2px;
  border: 2px solid var(--global-purple-400, #e4e3ff);
  background: var(--global-purple-400, #e4e3ff);
  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);
}

.event-notification-table {
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e0e0e1;
  margin-top: 31px;
}

.event-notification-table-row {
  display: flex;
  flex-direction: row;
  padding: 10px 10px 10px 15px;
}

.event-notification-table-cell {
  width: 50%;
  display: flex;
}

.webhooks-details-disclaimer {
  display: flex;
  flex-direction: column;
  margin-top: 31px;
  gap: 6px;
}

.font-link {
  cursor: pointer;
}

.response-header {
  display: flex;
  padding: 10px 10px 10px 0px;
  justify-content: space-between;
  /* align-items: left; */
  gap: 10px;
}

.response-reponse-error {
  color: var(--text-highest, rgba(1, 1, 2, 0.92));
  font-family: Poppins !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.response-subheader {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.salt-id {
  display: flex;
  border-radius: 8px;
  align-items: center;
  border: 1px solid #d9d9d9;
  padding: 5.2px 10px;
  grid-gap: 15px;
  gap: 15px;
  margin-right: 12px;
  min-width: 200px;
  justify-content: space-between;
}

@media (width < 1000px) {
  .webhooks-details-summary {
    flex-direction: column;
    width: 100%;
  }

  .time-status-error-container .webhooks-details-summary-left-children {
    width: 100%;
  }

  .webhooks-details-summary-left {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Developers/Notification Logs/Webhook/webhookDetails.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,+DAA+D;EAC/D,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,+CAA+C;EAC/C,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".webhooks-details-root {\n  width: 100%;\n  padding: 24px 0px;\n}\n\n.webhooks-details-container {\n  width: 100%;\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  flex-shrink: 0;\n  padding: 30px;\n}\n\n.webhooks-details-summary {\n  display: flex;\n  gap: 46px;\n  width: 100%;\n}\n\n.webhooks-details-summary-left {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  width: 60%;\n}\n\n.webhooks-details-summary-left-children {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.webhooks-details-summary-right {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 30%;\n}\n\n.time-status-error-container {\n  display: flex;\n  flex-direction: row;\n  gap: 46px;\n}\n\n.webhooks-detailed-report {\n  display: flex;\n}\n\n.webhooks-detailed-report-root {\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n}\n\n.webhooks-detailed-report {\n  display: flex;\n  gap: 46px;\n}\n\n.webhooks-detailed-report-g {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px;\n}\n\n.active-elements {\n  display: flex;\n  padding: 5px 8px;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  border-radius: 2px;\n  border: 2px solid var(--global-purple-400, #e4e3ff);\n  background: var(--global-purple-400, #e4e3ff);\n  box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 0.02);\n}\n\n.event-notification-table {\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n  border: 1px solid #e0e0e1;\n  margin-top: 31px;\n}\n\n.event-notification-table-row {\n  display: flex;\n  flex-direction: row;\n  padding: 10px 10px 10px 15px;\n}\n\n.event-notification-table-cell {\n  width: 50%;\n  display: flex;\n}\n\n.webhooks-details-disclaimer {\n  display: flex;\n  flex-direction: column;\n  margin-top: 31px;\n  gap: 6px;\n}\n\n.font-link {\n  cursor: pointer;\n}\n\n.response-header {\n  display: flex;\n  padding: 10px 10px 10px 0px;\n  justify-content: space-between;\n  /* align-items: left; */\n  gap: 10px;\n}\n\n.response-reponse-error {\n  color: var(--text-highest, rgba(1, 1, 2, 0.92));\n  font-family: Poppins !important;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.response-subheader {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.salt-id {\n  display: flex;\n  border-radius: 8px;\n  align-items: center;\n  border: 1px solid #d9d9d9;\n  padding: 5.2px 10px;\n  grid-gap: 15px;\n  gap: 15px;\n  margin-right: 12px;\n  min-width: 200px;\n  justify-content: space-between;\n}\n\n@media (width < 1000px) {\n  .webhooks-details-summary {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .time-status-error-container .webhooks-details-summary-left-children {\n    width: 100%;\n  }\n\n  .webhooks-details-summary-left {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
